fx.ns("shared.screens", class SizeAlbum extends shared.screens.BaseChoiceScreen 
    {
        constructor()
        {
            super();
    
            this.showNext = false;
            this.showBack = fx.get("mode") == "creating";

            this.styleChoice = "circle";

            this.containerHeight = 450;

            this.title = fx.text("Choisissez la taille de votre album");
        }
        
        get currentShape()
        {
            return (fx.get("mode") == "creating") ? this.data.choosedShape : this.data.creation.shape_option;
        }

        get currentFormat()
        {
            return (fx.get("mode") == "creating") ? this.data.choosedFormat : this.data.creation.formatid;
        }

        set currentFormat(val)
        {
            if (fx.get("mode") == "creating")
                this.data.choosedFormat = val;
            else
                this.data.creation.formatid = val;
        }
    
        create() 
        {
            super.create();
    
            if (!this.data.creationFormats)
            {
                this.loading(true, fx.text("Chargement"));
                this.data.loadBookFormats();
            }
            else
                this.build();
        }
    
    
        onDataEvent(e)
        {
            if (e.type == "book-format-loaded")
                this.build();
        }
    
        build() 
        {
            super.build();

            let formats = this.data.availableFormats(this.data.choosedShape).sort(function (a, b) { return a.width - b.width; });
    
            for (let i = 0; i < formats.length; i++) 
            {
                let format = formats[i];
    
                let choice = new shared.components.ProductChoice("circle", format,  this.data.getFormatAsset(this.data.choosedShape, format.size), fx.text(format.title_new), fx.text(format.dimensions), fx.text("A partir de <strong>$€</strong>", format.price));
                if (this.currentFormat == format.id)
                    choice.addClass("selected");
    
                this.addChoice(choice, fx.browser.isDesktop ? { width: 190, height:  320} : { width: 190, height:  320, left : "center" })
            }
    
            this.loading(false);
        }
    
        onChoiceClicked(format)
        {
            this.currentFormat = format.id;
            
            if (fx.get("mode") == "creating") 
                this.data.event("next-step");
            else
                this.trigger("reset-navigation");
        }
    
    });